import i18n from '@/i18n'

export const getErrorText = (error_code) => {
	switch (error_code) {
		// Errors from OT.initPublisher() && Session.publish()
		case 'OT_CHROME_MICROPHONE_ACQUISITION_ERROR':
			return {
				main: `${i18n.global.t(
					'meetings_tokbox_OT_CHROME_MICROPHONE_ACQUISITION_ERROR'
				)} 😢`,
				sub: i18n.global.t(
					'meetings_tokbox_OT_CHROME_MICROPHONE_ACQUISITION_ERROR_desc'
				),
			}
			break

		case 'OT_USER_MEDIA_ACCESS_DENIED':
			return {
				main: `${i18n.global.t(
					'meetings_tokbox_OT_USER_MEDIA_ACCESS_DENIED'
				)} 😢`,
				sub: i18n.global.t('meetings_tokbox_OT_USER_MEDIA_ACCESS_DENIED_desc'),
			}
			break

		case 'OT_USER_SCREEN_MEDIA_DENIED':
			return {
				main: `${i18n.global.t(
					'meetings_tokbox_OT_USER_SCREEN_MEDIA_DENIED'
				)} 😢`,
				sub: i18n.global.t('meetings_tokbox_OT_USER_SCREEN_MEDIA_DENIED'),
			}
			break

		case 'OT_HARDWARE_UNAVAILABLE':
			return {
				main: `${i18n.global.t('meetings_tokbox_OT_HARDWARE_UNAVAILABLE')} 😢`,
				sub: i18n.global.t('meetings_tokbox_OT_HARDWARE_UNAVAILABLE_desc'),
			}
			break

		case 'OT_NO_DEVICES_FOUND':
			return {
				main: `${i18n.global.t('meetings_tokbox_OT_NO_DEVICES_FOUND')} 😢`,
				sub: i18n.global.t('meetings_tokbox_OT_NO_DEVICES_FOUND_desc'),
			}
			break

		case 'OT_SCREEN_SHARING_NOT_SUPPORTED':
			return {
				main: `${i18n.global.t(
					'meetings_tokbox_OT_SCREEN_SHARING_NOT_SUPPORTED'
				)} 😢`,
				sub: i18n.global.t(
					'meetings_tokbox_OT_SCREEN_SHARING_NOT_SUPPORTED_desc'
				),
			}
			break

		case 'OT_MEDIA_ERR_ABORTED':
		case 'OT_MEDIA_ERR_DECODE':
		case 'OT_MEDIA_ERR_SRC_NOT_SUPPORTED':
		case 'OT_NOT_SUPPORTED':
		case 'OT_NO_VALID_CONSTRAINTS':
		case 'OT_CONSTRAINTS_NOT_SATISFIED':
		case 'OT_CREATE_PEER_CONNECTION_FAILED':
		case 'OT_INVALID_PARAMETER':
		case 'OT_STREAM_CREATE_FAILED':
		case 'OT_TIMEOUT':
		case 'OT_SET_REMOTE_DESCRIPTION_FAILED':
		case 'OT_MEDIA_ERR_NETWORK':
		case 'OT_ICE_WORKFLOW_FAILED':
		case 'OT_UNEXPECTED_SERVER_RESPONSE':
			return {
				main: i18n.global.t('meetings_live_error_generic'),
			}
			break

		//Errors from calling Session.connect()
		case 'OT_NOT_CONNECTED':
		case 'OT_CONNECT_FAILED':
		case 'OT_AUTHENTICATION_ERROR':
		case 'OT_BADLY_FORMED_RESPONSE':
		case 'OT_TERMS_OF_SERVICE_FAILURE':
		case 'OT_INVALID_HTTP_STATUS':
		case 'OT_XDOMAIN_OR_PARSING_ERROR':
		case 'OT_CONNECTION_LIMIT_EXCEEDED':
		case 'OT_EMPTY_RESPONSE_BODY':
		case 'OT_INVALID_SESSION_ID':
		case 'OT_INVALID_PARAMETER':
			return {
				main: `${i18n.global.t('meetings_live_error_droppedconnection')} 😢`,
			}
			break

		case 'BUBBLE_NOTFOUND':
			return {
				main: `${i18n.global.t('meetings_live_error_bubble')} 😢`,
			}
			break

		case 'MEETINGS_DISABLED':
			return {
				main: `${i18n.global.t('apierrors_MEETINGS_DISABLED')} 😢`,
			}
			break

		default:
			// eslint-disable-next-line no-console
			console.log(error_code)
			break
	}
}
